<div class="modal-header">
  <h4 class="modal-title text-center" translate>pick_wallet</h4>
</div>
<div class="modal-body extra-padding">
  <p class="color-dark-blue text-center mt-2 mb-5 font-sm-15 fw-semibold">
    {{"usdt_raised" | translate}} ${{usdRaised}} / ${{tokenSoldData}}
  </p>
  <button type="button" class="btn btn-sm btn-outline-dark w-100 d-md-block d-none" (click)="connectWallet('metamask')">
    <svg-icon src="./assets/images/metamask.svg" [svgStyle]="{ 'width.px':32, 'height.px':32 }" ></svg-icon>
    <span class="d-inline-block" translate>metamask</span>
  </button>
  <button type="button" class="btn btn-sm btn-outline-dark w-100 mt-4 d-md-none mb-5" (click)="connectWallet('metawallet')">
    <svg-icon src="./assets/images/metamask.svg" [svgStyle]="{ 'width.px':32, 'height.px':32 }" ></svg-icon>
    <span class="d-inline-block" translate>Metamask Wallet(V1)</span>
  </button>
  <button type="button" class="btn btn-sm btn-outline-dark w-100 mt-4 mb-5" (click)="connectWallet('wallet')">
    <svg-icon src="./assets/images/wallet_connect.svg" [svgStyle]="{ 'width.px':32, 'height.px':32 }" ></svg-icon>
    <span class="d-inline-block" translate>wallet_connect</span>
  </button>

  <div class="footer mt-5">
    <button type="button" class="btn btn-sm btn-outline-dark w-100" (click)="modalRef.hide()" translate>cancel</button>
  </div>

</div>
